import React from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { TablePagination2 } from '../../../../components/TablePagination'
import { ProductsTableProps } from '../productsTable'
import { IServerTableData } from '../../../../types/tableTypes'
import { ExternalProductModel } from '../../../../server/mpsklad_core/Models/ExternalProductModel'

interface PaginationProps<TProducts extends IServerTableData<TRow, TColumnId>,
  TRow extends ExternalProductModel,
  TColumnId extends string> extends Pick<ProductsTableProps<TProducts, TRow, TColumnId>, 'products'> {
}

export const Pagination =
  observer(<TProducts extends IServerTableData<TRow, TColumnId>,
    TRow extends ExternalProductModel,
    TColumnId extends string>({products}: PaginationProps<TProducts, TRow, TColumnId>) => {

    const classes = useStyles()

    return (
      <Box
        className={classes.wrapper}
      >
        <TablePagination2
          table={products}
          labelRowsPerPage="Товаров на странице:"
          className={classes.pagination}
          view={'row'}
        />
      </Box>
    )
  })

const useStyles = makeStyles(
  (theme) => ({
    pagination: {
      position: 'absolute',
      top: 0,
      right: 90,
      color: theme.palette.mpSkladPrimary.gray,
      fontSize: 10
    },
    wrapper: {
      marginLeft: 'auto'
    }
  }))